import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Avatar, Box, Button, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Tab, Tabs, Typography } from "@mui/material";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import moment from "moment";

import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";
import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { Destinatarios } from "./Destinatarios";

import { ObtenerSubTipoAcuerdo } from "../../../connections/catalogos/SubTipoAcuerdoConnection";
import { ObtenerPlantilla, ObtenerPlantillaDetalle } from "../../../connections/admin/PlantillaConnection";
import { ActualizarEstatusOficio, GuardarOficio, DetalleOficio } from "../../../connections/tribunal/OficioConnection";

import { PlantillaProps } from "../../../interfaces/admin/PlantillaInterface";
import { SubTipoAcuerdoProps } from "../../../interfaces/catalogos/SubTipoAcuerdoInterface";
import { defaultDependencia, DependenciaProps } from "../../../interfaces/catalogos/DependenciaInterface";
import { ActualizarOficioParams, defaultOficio, DestinatarioProps, OficioProps } from "../../../interfaces/tribunal/OficioInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

const defaultDocument = DefaultDocumentEditor();

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const ElaborarOficioPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { Id } = useParams();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [value, setValue] = useState( 0 );

    const [oficio, setOficio] = useState<OficioProps>( defaultOficio );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillasArray, setPlantillasArray] = useState<PlantillaProps[]>( [] );

    const [subtipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );
    const [subtipoAcuerdoArray, setSubTipoAcuerdoArray] = useState<SubTipoAcuerdoProps[]>( [] );

    const [destinatarios, setDestinatarios] = useState<DestinatarioProps[]>( [] );
    const [dependencia, setDependencia] = useState<DependenciaProps>( defaultDependencia );
    const [tieneDomicilioDependencia, setTieneDomicilioDependencia] = useState( false );

    const [cadenaActores, setCadenaActores] = useState( '' );
    const [cadenaDemandados, setCadenaDemandados] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [editorReady, setEditorReady] = useState( false );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [firmaJuez, setFirmaJuez] = useState( false );

    const cumplimientoEjecutoria = oficio.idAmparo !== 0 && subtipoAcuerdo === 17;

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: ActualizarOficioParams = {
            idOficio:           Id ?? '',
            idPlantilla:        plantilla,
            contenido:          syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            idSubtipoAcuerdo:   subtipoAcuerdo,
            firmoJuez:          firmaJuez
        }

        return await GuardarOficio( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch(openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch(openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusOficio({ idOficio: Id ?? '', idEstatus: firmaJuez ? 44 : 45, observaciones: '' }).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if ( success ) {

                    if ( !firmaJuez && asignadoMismoUsuario ) {

                        navigate(`/Tribunal/oficio/visualizar/${ Id ?? '' }`);

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                    }

                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleChangePlantilla = async ( value: number ) => {

        setPlantilla( value );

        await ObtenerPlantillaDetalle( value ).then(resp => {

            const { idPlantilla, contenido, } = resp;

            if ( idPlantilla !== 0 ) {

                if ( !(/<\/?[a-z][\s\S]*>/.test(contenido)) ) {

                    const contentSetValues = reemplaceData(contenido);

                    syncfusionEditor.current?.documentEditor.open(contentSetValues);

                }
                else if ( /<\/?[a-z][\s\S]*>/.test(contenido) ) {

                    const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                    const contentSetValues = reemplaceData(contenidoParser);

                    syncfusionEditor.current?.documentEditor.open(defaultDocument);

                    syncfusionEditor.current?.documentEditor.editor.insertText(contentSetValues);
                }
                else {
                    syncfusionEditor.current?.documentEditor.open(defaultDocument);
                }

            }

        });

    }

    const reemplaceData = ( contenido: string ) => {

        let contentSetValues = contenido
            .replaceAll('[Numero_Oficio]', oficio.numeroOficio ?? "")
            .replaceAll('[Juez]', oficio.juez ?? "")
            .replaceAll('[Dependencia]', oficio.dependencia?.descripcion ?? "");

        if ( oficio.idExpediente !== 0 ) {
            contentSetValues = contentSetValues
                .replaceAll('[Numero_Expediente]', oficio.expediente?.numeroExpediente ?? "")
                .replaceAll('[Numero_Folio]', oficio.expediente?.numeroFolio ?? "")
                .replaceAll('[Tipo_juicio]', oficio.expediente?.tipoJuicio ?? "")
                .replaceAll('[Juez_Expediente]', oficio.expediente?.juez ?? "")
                .replaceAll('[Juzgado_Origen]', oficio.expediente?.juzgadoOrigen ?? "")
                .replaceAll('[Secretario_Tramite]', oficio.expediente?.secretarioTramite ?? "")
                .replaceAll('[Secretario_Ejecucion]', oficio.expediente?.secretarioEjecucion ?? "")
                .replaceAll('[Secretario_TramiteMenor]', oficio.expediente?.secretarioTramiteMenor ?? "")
                .replaceAll('[Actores]', cadenaActores ?? "")
                .replaceAll('[Demandados]', cadenaDemandados ?? "")
                .replaceAll('[Fecha_Expediente]', oficio.expediente?.fecha ? moment( oficio.expediente.fecha ).format('DD-MM-YYYY') : "");

        }

        if ( oficio.idExhortoRecibido !== 0 ) {
            contentSetValues = contentSetValues
                .replaceAll('[Numero_Exhorto]', oficio.exhortoRecibido?.numeroExhorto ?? "")
                .replaceAll('[Numero_Expediente]', oficio.exhortoRecibido?.numeroExpedienteOrigen ?? "")
                .replaceAll('[Numero_Folio]', oficio.exhortoRecibido?.numeroFolio ?? "")
                .replaceAll('[Folio_Buzon]', oficio.exhortoRecibido?.folioBuzonElectronico ?? "")
                .replaceAll('[Tipo_juicio]', oficio.exhortoRecibido?.tipoJuicio ?? "")
                .replaceAll('[Juez_Exhorto]', oficio.exhortoRecibido?.juez ?? "")
                .replaceAll('[Juzgado_Origen]', oficio.exhortoRecibido?.juzgadoOrigen ?? "")
                .replaceAll('[Autoridad_Exhorto]', oficio.exhortoRecibido?.autoridadExhortoRecibido ?? "")
                .replaceAll('[Secretario_Tramite]', oficio.exhortoRecibido?.secretario ?? "")
                .replaceAll('[Actores]', cadenaActores ?? "")
                .replaceAll('[Demandados]', cadenaDemandados ?? "")
                .replaceAll('[Fecha_Exhorto]', oficio.exhortoRecibido?.fecha ? moment( oficio.exhortoRecibido.fecha ).format('DD-MM-YYYY') : "");

        }

        if ( oficio.idIrregular !== 0 ) {
            contentSetValues = contentSetValues
                .replaceAll('[Numero_Irregular]', oficio.irregular?.numeroIrregular ?? "")
                .replaceAll('[Numero_Expediente]', oficio.irregular?.numeroExpediente ?? "")
                .replaceAll('[Juez_Irregular]', oficio.irregular?.juez ?? "")
                .replaceAll('[Juzgado_Origen]', oficio.irregular?.juzgadoOrigen ?? "")
                .replaceAll('[Secretario_Tramite]', oficio.irregular?.secretario ?? "")
                .replaceAll('[Actores]', cadenaActores ?? "")
                .replaceAll('[Demandados]', cadenaDemandados ?? "")
                .replaceAll('[Fecha_Irregular]', oficio.irregular?.fecha ? moment( oficio.irregular.fecha ).format('DD-MM-YYYY') : "");

        }

        if ( oficio.idAmparo !== 0 ) {
            const cadenaPartes = (oficio.amparo?.partes ?? []).map(p => `${p.persona} (${p.tipoParte})`).join(', ');

            contentSetValues = contentSetValues
                .replaceAll('[Numero_Amparo]', oficio.amparo?.numeroAmparo ?? "")
                .replaceAll('[Numero_Expediente]', oficio.amparo?.numeroExpediente ?? "")
                .replaceAll('[Tipo_Amparo]', oficio.amparo?.tipoAmparo ?? "")
                .replaceAll('[Amparo_Origen]', oficio.amparo?.numeroAmparoOrigen ?? "")
                .replaceAll('[Juez_Amparo]', oficio.amparo?.juez ?? "")
                .replaceAll('[Juzgado_Origen]', oficio.amparo?.juzgadoOrigen ?? "")
                .replaceAll('[Secretario_Tramite]', oficio.amparo?.secretario ?? "")
                .replaceAll('[Partes_Amparo]', cadenaPartes)
                .replaceAll('[Fecha_Amparo]', oficio.amparo?.fecha ? moment( oficio.amparo.fecha ).format('DD-MM-YYYY') : "");

        }

        return contentSetValues;
    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerSubTipoAcuerdo( 12 ).then(resp => {
                setSubTipoAcuerdoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerPlantilla({
                idTipoAcuerdo: 20,
                idSubTipoAcuerdo: 0,
                idTipoNotificacion: 0,
                idAutoridad: 0
            }).then(resp => {
                setPlantillasArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleOficio( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setOficio( resp );

                        contenidoRef.current = resp.contenido;

                        setSubTipoAcuerdo( resp.idSubTipoAcuerdo );
                        setPlantilla( resp.idPlantilla );
                        setFirmaJuez( resp.firmaJuez );
                        setDestinatarios( resp.destinatarios );
                        setDependencia( resp.dependencia ?? defaultDependencia );

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = (arr: string[]) => arr.join(', ');
                        const fmtDate = (d: any) => d ? moment(d).format('DD-MM-YYYY') : '';

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Numero de Oficio', '2', resp.numeroOficio),
                        ];

                        if ( resp.idExpediente !== 0 ) {
                            const { expediente: e } = resp;
                            const cadenaA = joinNames(e.actores);
                            const cadenaD = joinNames(e.demandados);
                            setCadenaActores(cadenaA);
                            setCadenaDemandados(cadenaD);
                            items.push(
                                ...mkItem('Número de Expediente', '4', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '6', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', e.juzgadoOrigen),
                                ...mkItem('Fecha del Expediente', '11', fmtDate(e.fecha)),
                                ...mkItem('Actor(es)', '12', cadenaA),
                                ...mkItem('Demandado(s)', '13', cadenaD),
                                ...mkItem('Juez', '13', e.juez),
                            );
                            if ( e.numeroFolio )            items.push(...mkItem('Número de Folio', '14', e.numeroFolio));
                            if ( e.secretarioTramite )      items.push(...mkItem('Secretario de Tramite', '5', e.secretarioTramite));
                            if ( e.secretarioTramiteMenor ) items.push(...mkItem('Secretario de Tramite Menor', '7', e.secretarioTramiteMenor));
                            if ( e.secretarioEjecucion )    items.push(...mkItem('Secretario de Ejecucion', '15', e.secretarioEjecucion));
                        }

                        if ( resp.idExhortoRecibido !== 0 ) {
                            const { exhortoRecibido: ex } = resp;
                            const cadenaA = joinNames(ex.actores);
                            const cadenaD = joinNames(ex.demandados);
                            setCadenaActores(cadenaA);
                            setCadenaDemandados(cadenaD);
                            items.push(
                                ...mkItem('Número de Exhorto', '4', ex.numeroExhorto),
                                ...mkItem('Tipo de Juicio', '6', ex.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', ex.juzgadoOrigen),
                                ...mkItem('Fecha del Exhorto', '11', fmtDate(ex.fecha)),
                                ...mkItem('Actor(es)', '12', cadenaA),
                                ...mkItem('Demandado(s)', '13', cadenaD),
                                ...mkItem('Juez', '13', ex.juez),
                                ...mkItem('Autoridad del Exhorto', '13', ex.autoridadExhortoRecibido),
                            );
                            if ( ex.numeroFolio )             items.push(...mkItem('Número de Folio', '14', ex.numeroFolio));
                            if ( ex.secretario )              items.push(...mkItem('Secretario de Tramite', '5', ex.secretario));
                            if ( ex.numeroExpedienteOrigen )  items.push(...mkItem('Número de Expediente Origen', '7', ex.numeroExpedienteOrigen));
                        }

                        if ( resp.idIrregular !== 0 ) {
                            const { irregular: ir } = resp;
                            const cadenaA = joinNames(ir.actores);
                            const cadenaD = joinNames(ir.demandados);
                            setCadenaActores(cadenaA);
                            setCadenaDemandados(cadenaD);
                            items.push(
                                ...mkItem('Número Irregular', '4', ir.numeroIrregular),
                                ...mkItem('Número de Expediente', '6', ir.numeroExpediente),
                                ...mkItem('Juzgado Origen', '10', ir.juzgadoOrigen),
                                ...mkItem('Fecha del Irregular', '11', fmtDate(ir.fecha)),
                                ...mkItem('Juez', '13', ir.juez),
                            );
                            if ( ir.actores.length > 0 )   items.push(...mkItem('Actor(es)', '12', cadenaA));
                            if ( ir.demandados.length > 0 ) items.push(...mkItem('Demandado(s)', '13', cadenaD));
                            if ( ir.secretario )            items.push(...mkItem('Secretario de Tramite', '5', ir.secretario));
                        }

                        if ( resp.idAmparo !== 0 ) {
                            const { amparo: am } = resp;
                            const cadenaPartes = am.partes
                                .map(p => `${p.persona} (${p.tipoParte})`).join(', ');
                            items.push(
                                ...mkItem('Número de Amparo', '4', am.numeroAmparo),
                                ...mkItem('Juzgado Origen', '10', am.juzgadoOrigen),
                                ...mkItem('Partes del Amparo', '12', cadenaPartes),
                                ...mkItem('Fecha del Amparo', '11', fmtDate(am.fecha)),
                                ...mkItem('Juez', '13', am.juez),
                                ...mkItem('Autoridad del Amparo', '13', am.autoridadAmparo),
                            );
                            if ( am.numeroAmparoOrigen ) items.push(...mkItem('Numero de Amparo Origen', '15', am.numeroAmparoOrigen));
                            if ( am.numeroExpediente )   items.push(...mkItem('Número de Expediente', '6', am.numeroExpediente));
                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 43 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 43 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if( Id ){
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Oficio' }, { text: 'Elaborar oficio' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ oficio.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Oficio" {...TabProps(0)} />
                                        <Tab label="Destinatario(s)" {...TabProps(1)} />

                                        <Tab
                                            label="Información del amparo"
                                            sx={{ display: oficio.idAmparo !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(3)}
                                        />

                                        <Tab
                                            label="Información del expediente"
                                            sx={{ display: oficio.idExpediente !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(4)}
                                        />

                                        <Tab
                                            label="Información del exhorto"
                                            sx={{ display: oficio.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(5)}
                                        />

                                        <Tab
                                            label="Información del irregular"
                                            sx={{ display: oficio.idIrregular !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(6)}
                                        />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GOF-${oficio.idOficio}` }
                                            fecha={ oficio.fecha ?? new Date() }
                                            juez={ oficio.juez }
                                            numeroOficio={ oficio.numeroOficio }
                                        />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            <Grid size={{ md: oficio.idAmparo !== 0  ? 6 : 12, xs: 12 }}>

                                                <FormControl fullWidth>

                                                    <InputLabel>Plantilla</InputLabel>

                                                    <Select
                                                        label="Plantilla"
                                                        value={ plantilla }
                                                        onChange={ (e) => handleChangePlantilla(e.target.value) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            plantillasArray
                                                            .map((elem) => (
                                                                <MenuItem key={ elem.idPlantilla } value={ elem.idPlantilla }> {elem.descripcion} </MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            {
                                                oficio.idAmparo !== 0
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <FormControl fullWidth>

                                                            <InputLabel>Tipo de oficio de amparo</InputLabel>

                                                            <Select
                                                                label="Tipo de oficio de amparo"
                                                                value={ subtipoAcuerdo }
                                                                onChange={ (e) => setSubTipoAcuerdo( e.target.value ) }
                                                            >
                                                                <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                {
                                                                    subtipoAcuerdoArray
                                                                    .filter(({ idSubTipoAcuerdo }) => [ 29, 30, 17 ].includes( idSubTipoAcuerdo ))
                                                                    .sort(( a, b ) => [ 29, 30, 17 ].indexOf( a.idSubTipoAcuerdo ) - [ 29, 30, 17 ].indexOf( b.idSubTipoAcuerdo ))
                                                                    .map((elem) => (
                                                                        <MenuItem key={ elem.idSubTipoAcuerdo } value={ elem.idSubTipoAcuerdo }> {elem.descripcion} </MenuItem>
                                                                    ))
                                                                }
                                                            </Select>

                                                        </FormControl>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <FormControl>

                                                    <FormLabel>¿El oficio será firmado por el juez?</FormLabel>
                                                    <RadioGroup row>

                                                        <FormControlLabel
                                                            label="Si"
                                                            control={
                                                                <Radio
                                                                    checked={ firmaJuez }
                                                                    onChange={ () => setFirmaJuez( true ) }
                                                                />
                                                            }
                                                        />

                                                        <FormControlLabel
                                                            label="No"
                                                            control={
                                                                <Radio
                                                                    checked={ !firmaJuez }
                                                                    onChange={ () => setFirmaJuez( false ) }
                                                                />
                                                            }
                                                        />

                                                    </RadioGroup>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key='DocumentEditorContainer'
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height='650'
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                    created={ handleEditorCreated }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>

                                            {
                                                oficio.observaciones.length !== 0
                                                &&
                                                    <Grid size={{ xs: 12, md: 12 }}>

                                                        <Card sx={{ p: 2 }}>

                                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                                Observaciones
                                                            </Typography>

                                                            <Stack spacing={ 2 }>

                                                                {
                                                                    oficio.observaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                        <Box key={ i } sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>

                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    bgcolor: (theme) => theme.palette.primary.main,
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                { usuario.split(" ").slice(0, 2).map(n => n[0]).join("") }
                                                                            </Avatar>

                                                                            <Box
                                                                                sx={{
                                                                                    flex: 1,
                                                                                    bgcolor: "action.hover",
                                                                                    border: "0.5px solid",
                                                                                    borderColor: "divider",
                                                                                    borderRadius: "0 15px 15px 15px",
                                                                                    px: 2,
                                                                                    py: 1.25,
                                                                                }}
                                                                            >
                                                                                <Typography variant="subtitle2" fontWeight={ 500 }>
                                                                                    { usuario } { puesto ? `(${ puesto })` : '' }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                    { observacion }
                                                                                </Typography>

                                                                                {
                                                                                    fecha
                                                                                    &&
                                                                                        <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                        {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                        </Typography>

                                                                                }

                                                                            </Box>

                                                                        </Box>

                                                                    ))
                                                                }

                                                            </Stack>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            variant="outlined"
                                                            loading={ loadingGuardar }
                                                            onClick={ handleGuardar }
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 6, xs: 12 }} style={{ textAlign: 'left' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                            disabled={ cumplimientoEjecutoria && ( dependencia.idDependencia === 0 || !tieneDomicilioDependencia ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Destinatarios
                                        setDependencia={ setDependencia }
                                        setDestinatarios={ setDestinatarios }
                                        dependencia={ dependencia }
                                        destinatarios={ destinatarios }
                                        cumplimientoEjecutoria={ cumplimientoEjecutoria }
                                        setTieneDomicilioDependencia={ setTieneDomicilioDependencia }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <BoxInformacionAmparo
                                        amparo={ oficio.amparo }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <BoxInformacionExpediente
                                        expediente={ oficio.expediente }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <BoxInformacionExhortoRecibido
                                        exhortoRecibido={ oficio.exhortoRecibido }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <BoxInformacionIrregular
                                        irregular={ oficio.irregular }
                                    />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la elaboración del oficio?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar(false) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
